import request from "@/util/request";
// 角色管理 - 获取数据
export function getRoleListByPage(data) {
  return request({
    url: "/api/config/system/getRoleListByPage",
    method: "get",
    params: data
  });
}
// 角色管理 - 获取页面配置
export function getPermissionTree(data) {
  return request({
    url: "/api/config/system/GetPermissionTree",
    method: "get",
    params: data
  });
}
// 角色管理 - 添加、编辑角色
export function addOrUpdateRole(data) {
  return request({
    url: "/api/config/system/AddOrUpdateRole",
    method: "post",
    data
  });
}
// 角色管理 - 删除角色
export function removeRole(data) {
  return request({
    url: "/api/config/system/RemoveRole",
    method: "delete",
    data
  });
}
// 账号管理 获取部门
export function getDeptList(data) {
  return request({
    url: "/api/config/system/getDeptList",
    method: "get",
    params: data
  });
}
// 账号管理 获取列表
export function getAccountList(data) {
  return request({
    url: "/api/config/system/getAccountList",
    method: "get",
    params: data
  });
}
// 账号管理 获取多选的角色
export function getAllRoleList(data) {
  return request({
    url: "/api/config/system/getAllRoleList",
    method: "get",
    params: data
  });
}

// 账号管理 - 添加、编辑角色
export function addOrUpdateAccount(data) {
  return request({
    url: "/api/config/system/AddOrUpdateAccount",
    method: "post",
    data
  });
}
// 部门管理 - 添加、编辑部门
export function AddOrUpdateDepartment(data) {
  return request({
    url: "/api/config/system/AddOrUpdateDepartment",
    method: "post",
    data
  });
}
// 部门管理 - 删除部门
export function removeDepartment(data) {
  return request({
    url: "/api/config/system/RemoveDepartment",
    method: "delete",
    data
  });
}
// 部门管理 - 删除部门
export function removeAccount(data) {
  return request({
    url: "/api/config/system/RemoveAccount",
    method: "delete",
    data
  });
}
// 修改密码
export function changePassword(data) {
  return request({
    url: "/api/config/system/ChangePassword",
    method: "post",
    data
  });
}

// 已授权站点 - 获取列表
export function AuthorizedStationGetList(data) {
  return request({
    url: "/api/config/system/AuthorizedStationGetList",
    method: "GET",
    params:data
  });
}
// 已授权站点 - 增加
export function AuthorizedStationAdd(data) {
  return request({
    url: "/api/config/system/AuthorizedStationAdd",
    method: "POST",
    data
  });
}
// 已授权站点 - 删除
export function AuthorizedStationRemove(data) {
  return request({
    url: "/api/config/system/AuthorizedStationRemove",
    method: "DELETE",
    data
  });
}
// 重置密码
export function ResetPassword(data) {
  return request({
    url: "/api/config/system/ResetPassword",
    method: "POST",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/system.js